import axios from 'axios'

const options = {
  headers: { 'Content-Type': 'application/json' },
}

// if (process.env.NODE_ENV !== 'production') {
//   options.baseURL = 'http://127.0.0.1:3000'
// }

const API = axios.create(options)

export default API
